import apiBase from "../../api/axios";

const BASE = "v1/talentos-global";

/**
 * Obtiene las 5 conversaciones globales para los selectores.
 * GET /api/v1/talentos-global/selectores/conversaciones/
 */
export const getConversacionesSelectoresService = async () => {
  const response = await apiBase.get(`${BASE}/selectores/conversaciones/`);
  return response.data;
};

/**
 * Obtiene la configuración existente para un talento, agrupada por conversación.
 * GET /api/v1/talentos-global/configuraciones-conducir/por-talento/?talento={id}
 */
export const getConfiguracionPorTalentoService = async (talentoId) => {
  const response = await apiBase.get(
    `${BASE}/configuraciones-conducir/por-talento/?talento=${talentoId}`
  );
  return response.data;
};

/**
 * Crea o actualiza todas las configuraciones de conversación para un talento.
 * POST /api/v1/talentos-global/configuraciones-conducir/crear-por-talento/
 */
export const crearConfiguracionPorTalentoService = async (payload) => {
  const response = await apiBase.post(
    `${BASE}/configuraciones-conducir/crear-por-talento/`,
    payload
  );
  return response.data;
};
